// List activity is a real message, never a ticket/assignment/system clock.
export function isRealListMessage(message) {
  return Boolean(message && message.kind !== 'system' && message.content?.kind !== 'system' && message.direction !== 'system'
    && (message.kind || message.content?.kind || ['inbound', 'outbound'].includes(message.direction) || typeof message.text === 'string'));
}
const timestamp = value => { const n = value ? Date.parse(value) : NaN; return Number.isFinite(n) ? n : null; };
export function listMessageTime(conversation, activity) {
  const preview = isRealListMessage(conversation?.last_message) ? timestamp(conversation.last_message.occurred_at || conversation.last_message.created_at) : null;
  const live = timestamp(activity?.at);
  return preview != null || live != null ? Math.max(preview ?? -Infinity, live ?? -Infinity) : timestamp(conversation?.last_activity_at);
}
export function sortMessageConversations(rows, activity = {}) {
  return [...rows].sort((a, b) => {
    const left = listMessageTime(a, activity[a.id]), right = listMessageTime(b, activity[b.id]);
    return left == null || right == null ? 0 : right - left;
  });
}
export function recordListMessageActivity(state, id, message, fallbackTime) {
  if (!id || !isRealListMessage(message)) return state;
  const at = message.created_at || message.occurred_at || fallbackTime || null;
  const previous = state.realMessageActivity?.[id];
  if (previous && (timestamp(previous.at) ?? -Infinity) > (timestamp(at) ?? -Infinity)) return state;
  return { ...state, realMessageActivity: { ...state.realMessageActivity, [id]: { message_id: message.id || null, at } } };
}
export function liveListConversationIds(state) {
  return [...new Set([...Object.keys(state.realMessageActivity || {}), ...Object.keys(state.unblockedConversations || {})])].filter(id => state.conversations[id] && state.conversations[id].blocked === false);
}
export function visibleMessageConversations(state) {
  const scopes = Object.entries(state.conversationOrderByScope).filter(([key]) => !key.startsWith('filtered:'));
  const loaded = new Set(scopes.flatMap(([, ids]) => ids));
  const live = liveListConversationIds(state).filter(id => !loaded.has(id) && !scopes.some(([key]) => state.excludedConversationIdsByScope?.[key]?.[id]));
  return sortMessageConversations([...loaded, ...live].map(id => state.conversations[id]).filter(Boolean), state.realMessageActivity);
}
